import React from "react";
import FileIcon from "@mui/icons-material/LibraryBooks";
import FileIconOutlined from "@mui/icons-material/LibraryBooksOutlined";
import VideoIconOutlined from "@mui/icons-material/VideocamOutlined";
import ImageIcon from "@mui/icons-material/Image";
import WebIcon from "@mui/icons-material/Web";
import DocumentIcon from "@mui/icons-material/Description";
import VideoIcon from "@mui/icons-material/Videocam";
import LanguageIcon from "@mui/icons-material/Language";
import LinkIcon from "@mui/icons-material/Link";
import CourseSurveyIcon from "./CourseSurveyIcon";
import CourseQuizIcon from "@mui/icons-material/Help";
import PropTypes from "prop-types";
import * as constants from "../../constants";

function ResourceTypeIcon(props) {
  function createResourceIcon(resourceType) {
    let activity = resourceType.toLowerCase();
    switch (activity) {
      case constants.resourceTypes.video.toLowerCase():
        return !props.filled ? <VideoIconOutlined /> : <VideoIcon />;
      case constants.resourceTypes.file.toLowerCase():
        return !props.filled ? <FileIconOutlined /> : <FileIcon />;
      case constants.resourceTypes.image.toLowerCase():
        return <ImageIcon />;
      case constants.resourceTypes.website.toLowerCase():
        return <WebIcon />;
      case constants.resourceTypes.document.toLowerCase():
      case constants.resourceTypes.section.toLowerCase():
        return <DocumentIcon />;
      case constants.resourceTypes.scorm.toLowerCase():
        return <LanguageIcon />;
      case constants.resourceTypes.link.toLowerCase():
        return <LinkIcon />;
      case constants.resourceTypes.survey.toLowerCase():
        return <CourseSurveyIcon />;
      case constants.resourceTypes.quiz.toLowerCase():
        return <CourseQuizIcon />;
      default:
        return null;
    }
  }

  return props.type ? createResourceIcon(props.type) : null;
}

export default ResourceTypeIcon;

ResourceTypeIcon.propTypes = {
  type: PropTypes.string,
  filled: PropTypes.bool
};

ResourceTypeIcon.defaultProps = {
  filled: false
};
